import { registerPlugin, PluginListenerHandle } from '@capacitor/core';

export interface GlanceCobrowseInitOptions {
  groupId: number;
  visitorId?: string;
  site?: string;
}

export interface GlanceCobrowseStartOptions {
  key?: string;
}

export interface GlanceCobrowseSessionEvent {
  sessionCode?: string;
  sessionKey?: string;
}

export interface GlanceCobrowseErrorEvent {
  error: string;
}

export interface GlanceCobrowsePlugin {
  initVisitor(options: GlanceCobrowseInitOptions): Promise<void>;
  startSession(options?: GlanceCobrowseStartOptions): Promise<{ sessionCode?: string }>;
  endSession(): Promise<void>;
  isInSession(): Promise<{ inSession: boolean }>;

  addListener(eventName: 'sessionConnected', handler: () => void): Promise<PluginListenerHandle>;
  addListener(eventName: 'sessionEnded', handler: (event: GlanceCobrowseSessionEvent) => void): Promise<PluginListenerHandle>;
  addListener(eventName: 'agentConnected', handler: () => void): Promise<PluginListenerHandle>;
  addListener(eventName: 'sessionCodeReceived', handler: (event: GlanceCobrowseSessionEvent) => void): Promise<PluginListenerHandle>;
  addListener(eventName: 'error', handler: (event: GlanceCobrowseErrorEvent) => void): Promise<PluginListenerHandle>;
}

const GlanceCobrowse = registerPlugin<GlanceCobrowsePlugin>('GlanceCobrowse');

export { GlanceCobrowse };
